// src/api_scripts/getmultimediaList.js
import { fetchAllPages } from "../paginationUtils";

const getmultimediaList = async (multimediaListName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/multimedia-profile`;

  try {
    const dataArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Multimedia Profiles");
    console.log("Get Multimedia Profiles API Response Data (all pages):", dataArray.length, "items");
    return dataArray;

  } catch (error) {
    console.error(`Error fetching Multimedia Profiles:`, error);
    throw error;
  }
};

export default getmultimediaList;